import React from 'react';

import {ActivityIndicator} from 'components/ActivityIndicator';

import UserAgreementsTable from '../components/Table';

import {IndexPageLayout} from 'pac-platform-ui-components';

import {Box} from '@mantine/core';

import {useAuth} from 'hooks/useAuth';

import {useAccount} from 'hooks/useAccount';

export const IndexPage = () => {
    const account = useAccount();

    const { user, profile, session } = useAuth({ account });

    if (typeof profile === 'undefined' || profile === null) {
        return (
            <Box>
                <ActivityIndicator
                    label="Working...Please wait"
                    size="default"
                />
            </Box>
        );
    }

    let formatted = new Date(profile.tc.timestamp * 1000);

    let agreements = [
        {
            name: 'Panasonic Avionics Corporation Terms of Use',
            viewPath: '/user-agreements/terms-of-use',
            acceptedBy: profile.name,
            acceptedOn: formatted.toLocaleDateString(),
            acceptedIpAddress: profile.tc['ip-address'],
        },
    ];

    return (
        <IndexPageLayout title="Agreements">
            <UserAgreementsTable agreements={agreements} />
        </IndexPageLayout>
    );
};
